import { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { connect } from "react-redux";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Spinner,
} from "reactstrap";
import {
  setSelectedBrand as setSelectedBrandAction,
  updateBrandData as updateBrandDataAction,
} from "../../../ReduxToolkit/Reducers/brands";
import { updateWholeSalerData as updateWholeSalerDataAction } from "../../../ReduxToolkit/Reducers/wholesaler";
import { updateRetailer as updateRetailerAction } from "../../../ReduxToolkit/Reducers/retailers";
import {
  age,
  market,
  price,
  product_category,
  style,
  target_group,
  populateArray,
  eco_friendly,
  size,
  populateArray2,
  brand_rating_options,
  brand_awareness_options,
  ecom_rating_options,
  pos_rating_options,
  market_diversity_options,
  retailer_awareness_options,
} from "../../../static/brands_wholesalers_data";
import EditBrandFormFieldColumn from "./EditBrandFormFieldColumn";
import EditBrandFormFieldLocationColumn from "./EditBrandFormFieldLocationColumn";

const EditBrandModal = ({
  open,
  onClose,
  brand,
  type,
  updateRetailer,
  updateWholeSalerData,
  setSelectedBrand,
  updateBrandData,
}) => {
  const [loading, setLoading] = useState(false);
  const sortedTargetGroup = [...(brand.target_group || [])].sort((a, b) => {
    const aIsMen = a?.toLowerCase() === "men";
    const bIsMen = b?.toLowerCase() === "men";
    return aIsMen === bIsMen ? 0 : aIsMen ? -1 : 1;
  });

  const _brandAge = brand?.age?.length
    ? brand?.age
    : brand?.main_age
      ? [brand?.main_age]
      : [];
  const _brandStyle = brand?.style?.length
    ? brand?.style
    : brand?.main_style
      ? [brand?.main_style]
      : [];
  const _brandTargetGroup = sortedTargetGroup?.length
    ? sortedTargetGroup
    : brand?.main_target_group
      ? [brand?.main_target_group]
      : [];
  const _brandCategory = brand?.product_category?.length
    ? brand?.product_category
    : brand?.main_category
      ? [brand?.main_category]
      : [];

  const methods = useForm({
    defaultValues: {},
  });

  useEffect(() => {
    if (open) {
      methods.reset({
        age: populateArray(_brandAge, age),
        main_age: brand?.main_age,

        style: populateArray(_brandStyle, style),
        main_style: brand?.main_style,

        product_category: populateArray(_brandCategory, product_category),
        main_category: brand?.main_category,

        target_group: populateArray(_brandTargetGroup, target_group),
        main_target_group: brand?.main_target_group,

        market: populateArray(
          brand?.country
            ? [brand?.country]
            : [],
          market
        ),
        market_of_interest: populateArray(brand?.market_of_interest, market),
        price: populateArray(brand?.price, price),
        eco_friendly: brand?.eco_friendly
          ? populateArray([brand?.eco_friendly || ""], eco_friendly)
          : [],
        size: brand?.size ? populateArray([brand?.size || ""], size) : [],
        brandRating: populateArray2(
          [Math.ceil(brand?.brand_rating) || ""],
          brand_rating_options,
          "value"
        ),
        brandAwareness: populateArray2(
          [Math.ceil(brand?.brand_awareness).toFixed() || ""],
          brand_awareness_options,
          "value"
        ),

        retailerAwareness: populateArray2(
          [Math.ceil(brand?.retailer_awareness).toFixed() || ""],
          retailer_awareness_options,
          "value"
        ),

        ecomRating: populateArray2(
          [Math.ceil(brand?.ecom_rating).toFixed() || ""],
          ecom_rating_options,
          "value"
        ),
        posRating: populateArray2(
          [Math.ceil(brand?.pos_rating).toFixed() || ""],
          pos_rating_options,
          "value"
        ),

        marketDiversity: populateArray2(
          [Math.ceil(brand?.market_diversity).toFixed() || ""],
          market_diversity_options,
          "value"
        ),
        price_point: brand?.price_point ? populateArray([brand?.price_point || ""], price) : [],
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  const onSubmit = async (values) => {
    setLoading(true);
    const payload = {
      id: brand?.id,
      features: {
        age: values?.age?.map((v) => v?.label),
        main_age: values?.main_age,

        price: values?.price?.map((v) => v?.label),
        style: values?.style?.map((v) => v?.label),
        main_style: values?.main_style,

        country: values?.market?.length ? values?.market?.map((v) => v?.label)[0] : 'N/A',
        market_of_interest: values?.market_of_interest?.map((v) => v?.label),
        target_group: values?.target_group?.map((v) => v?.label),
        main_target_group: values?.main_target_group,

        product_category: values?.product_category?.map((v) => v?.label),
        main_category: values?.main_category,
      }
    };

    if (values?.eco_friendly)
      payload.features.eco_friendly = values?.eco_friendly[0]?.label;
    if (values?.size) payload.features.size = values?.size[0]?.label;

    if (values?.brandRating)
      payload.features.brand_rating = +values.brandRating[0]?.value;

    if (values?.brandAwareness && type === "brand")
      payload.features.brand_awareness = +values.brandAwareness[0]?.value;

    if (values?.retailerAwareness && type !== "brand")
      payload.features.retailer_awareness = +values.retailerAwareness[0]?.value;

    if (values?.ecomRating && type === "brand")
      payload.features.ecom_rating = +values.ecomRating[0]?.value;

    if (values?.posRating && type === "brand")
      payload.features.pos_rating = +values.posRating[0]?.value;

    if (values?.marketDiversity && type === "brand")
      payload.features.market_diversity = +values.marketDiversity[0]?.value;

    if (values?.price_point && type === "brand")
      payload.features.price_point = values?.price_point[0]?.label;

    const action =
      type === "brand"
        ? updateBrandData
        : type === "wholesaler"
          ? updateWholeSalerData
          : updateRetailer;


    const res = await action({ data: payload, isSelected: true });

    console.log("Res", res);

    if (res.statusCode === 200) {
      // setSelectedBrand({
      //   ...brand,
      //   ...payload.features,
      // });
      onClose();
    }

    setLoading(false);
  };

  const fieldsToExclude = {
    retailer: [
      "eco_friendly",
      "size",
      "market_of_interest",
      "ecomRating",
      "posRating",
      "brandAwareness",
      "marketDiversity",
      "price_point",
    ],
    brand: ["retailerAwareness"],
  };

  const filterdColumns =
    type in fieldsToExclude
      ? columns?.filter((c) => !fieldsToExclude[type].includes(c?.field))
      : columns;

  return (
    <Modal isOpen={open} toggle={onClose} style={{ maxWidth: "90vw" }}>
      <ModalHeader toggle={onClose}>
        <span
          style={{
            fontSize: "24px",
            fontWeight: "700",
            textTransform: "uppercase",
          }}
        >
          Edit DATA
        </span>
      </ModalHeader>
      <ModalBody>
        <FormProvider {...methods}>
          <div
            className="d-flex justify-content-between align-items-start"
            style={{ overflow: "auto" }}
          >
            {filterdColumns?.map((column) => {
              if (column?.title === "Location" || column?.title === 'Preferred Market' || column?.title === 'Market Of Interest') {
                return (
                  <EditBrandFormFieldLocationColumn
                    key={column?.field}
                    column={column}
                  />
                );
              }
              return (
                <EditBrandFormFieldColumn
                  key={column?.field}
                  column={column}
                  brand={brand}
                />
              );
            })}
          </div>
        </FormProvider>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          className="rounded-pill"
          onClick={methods.handleSubmit(onSubmit)}
          disabled={loading}
        >
          {loading ? <Spinner size="sm" color="light" /> : "Update"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const columns = [
  {
    title: "Age Group",
    field: "age",
  },
  {
    title: "Product Style",
    field: "style",
  },
  {
    title: "Category",
    field: "product_category",
  },
  {
    title: "Target Group",
    field: "target_group",
  },
  {
    title: "Market Of Interest",
    field: "market_of_interest",
  },
  {
    title: "Location",
    field: "market",
  },
  {
    title: "Price Range",
    field: "price",
  },
  {
    title: "Price Point",
    field: "price_point",
  },
  {
    title: "Eco Friendly",
    field: "eco_friendly",
  },
  {
    title: "Size",
    field: "size",
  },
  {
    title: "Brand Rating",
    field: "brandRating",
  },
  {
    title: "Brand Awareness",
    field: "brandAwareness",
  },
  {
    title: "Ecom Rating",
    field: "ecomRating",
  },
  {
    title: "POS Rating",
    field: "posRating",
  },
  {
    title: "Market Diversity",
    field: "marketDiversity",
  },
  {
    title: "Retailer Awareness",
    field: "retailerAwareness",
  },
]

const mapStateToProps = (state) => ({
  brand: state.brands.selectedBrand,
});

const mapDispatchToProps = {
  updateBrandData: updateBrandDataAction,
  updateWholeSalerData: updateWholeSalerDataAction,
  setSelectedBrand: setSelectedBrandAction,
  updateRetailer: updateRetailerAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditBrandModal);
